import { fetchApi } from './fetcher';

export type ProgressiveJackpotsResponseProps = {
    id: string;
    amount: number;
    prevAmount: number;
    time: number;
    prevTime: number;
    metadata: {};
    provider: string;
    type: 'PROG';
};

const state = 'mi';
const domain = 'casino.fanduel.com';

// TODO: ADJUST PROGRESSIVE JACKPOTS
export const getProgressiveJackpots = async (): Promise<ProgressiveJackpotsResponseProps[] | []> => {
    try {
        const jackpotsResponse = await fetchApi(
            `https://api.${state}.${domain}/jackpot/api/v1/jackpots`,
            {
                method: 'GET'
            },
            {
                excludeCredentials: true
            }
        );
        const jackpots = await jackpotsResponse.json();
        return jackpots;
    } catch (e) {
        console.log(`Could not get progressive jackpots: ${(e as Error).message}`);
        return [];
    }
};
